//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  computed: {
    nextLesson() {
      return this.$store.state.lessonsArray
        ? this.$store.state.lessonsArray[
            parseInt(this.$store.state.currentLessonIndex) + 1
          ]
        : null;
    },
  },
};
